const OPEN_STREET_MAP_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
const ESRI_DARK_GRAY_URL = 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}';

export const getMapTileUrl = (isDark = false) => (
    isDark ? ESRI_DARK_GRAY_URL : OPEN_STREET_MAP_URL
);

export const getMapTileAttribution = (isDark = false) => (
    isDark
        ? '&copy; <a href="https://www.esri.com/">Esri</a> &mdash; Esri, DeLorme, NAVTEQ'
        : '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
);
